const helpBold = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-7 .92c0-.19 0-.28.42-.55a2.51 2.51 0 0 0 1.38-2.21 2.7 2.7 0 0 0-2.75-2.75 2.74 2.74 0 0 0-2.39 1.38l-.46.82 1.56.92.46-.83a1 1 0 0 1 .83-.45.86.86 0 0 1 .91.91c0 .28-.09.37-.55.65a2.38 2.38 0 0 0-1.28 2.11v.92H9zm-1.87 2.75a.92.92 0 1 0 1.84 0 .92.92 0 0 0-1.84 0" clip-rule="evenodd"/></svg>',
};

export { helpBold as default };
